import { AppDownloadContent } from '../../../../components/AppDownloadModal/components/AppDownloadContent';
import trophyCatchesMobile from './assets/trophyCatches-mobile.png';
import trophyCatchesDesktop from './assets/trophyCatches-desktop.png';

interface IProps {
  displayName: string;
}

export const TrophyCatchesAppDownloadSection = ({ displayName }: IProps) => {
  return (
    <div className="mb-fw order-2 col-span-full px-6 sm:mx-16 sm:px-0 md:order-3 md:col-span-10 md:col-start-2 md:mx-0 lg:col-span-8 lg:col-start-3">
      <AppDownloadContent
        appDownloadSource="TrophyCatchesAppDownloadSection"
        contentHeader={`Check which species have trophy potential in ${displayName}`}
        contentHeaderVariant="xs"
        contentText=""
        className="rounded-lg bg-lake-fog sm:rounded-xxl"
        contentWrapperClassName="sm:p-0 sm:gap-0 md:pr-0 md:pt-4 lg:pt-10 lg:pb-0"
        image={trophyCatchesDesktop}
        imageMobile={trophyCatchesMobile}
        imageWrapperClassName="px-12 pt-4 sm:px-8 sm:py-0 md:pt-8 lg:pt-12 lg:px-12"
        showQRCodeHint
      />
    </div>
  );
};
